export default __webpack_public_path__ + "static/Drozdz-246b04302cedc4a5417e5c7878e8eeb2.jpeg";